import { User } from "@/types";

const KEYS = {
  USER: 'user',
  TOKEN: 'token',
  REFRESH_TOKEN: 'refresh_token',
}

function createSession({
  accessToken,
  refreshToken,
  user,
}: {
  accessToken: string;
  refreshToken: string;
  user: User;
}) {
  localStorage.setItem(KEYS.USER, JSON.stringify(user));
  localStorage.setItem(KEYS.TOKEN, accessToken);
  localStorage.setItem(KEYS.REFRESH_TOKEN, refreshToken);
}

function currentSession(): {
  user: User | undefined;
  token: string | null;
  refreshToken: string | null;
} | null {
  try {
    const storedUser = localStorage.getItem(KEYS.USER);
    const storedToken = localStorage.getItem(KEYS.TOKEN);
    const storedRefreshToken = localStorage.getItem(KEYS.REFRESH_TOKEN);

    const user: User | undefined = storedUser
      ? JSON.parse(storedUser)
      : undefined;

    return {
      user,
      token: storedToken,
      refreshToken: storedRefreshToken,
    };
  } catch (error) {
    console.error('Erro ao validar a sessão:', error);
    destroySession();
    return null;
  }
}

function destroySession(): void {
  try {
    Object.values(KEYS).forEach(key => {
      localStorage.removeItem(key);
    });
  } catch (error) {
    console.error('Erro ao destruir a sessão:', error);
    throw error;
  }
}

const AuthSession = {
  createSession,
  currentSession,
  destroySession,
};

export default AuthSession;
